import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import * as LI from 'lucide-react';
import { fundingUses } from '../mock';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) {
    const y = el.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};

export default function FlexibleFunding() {
  return (
    <section id="funding" className="py-24 bg-slate-50/40 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="chip">Flexible Funding</span>
            <h2 className="mt-5 text-4xl md:text-5xl font-bold tracking-tight text-[#0a2540] leading-[1.05]">
              Grow your business <span className="font-serif-display italic text-teal-600">on your terms</span>
            </h2>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">
              Sleek Business offers fast and flexible funding solutions tailored to your business rhythm. You repay a small pre-agreed percentage of your daily card takings — so busy months contribute more, and slower months require less.
            </p>
            <div className="mt-8 flex flex-wrap gap-6 text-sm text-slate-700">
              <div className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-teal-500"/> No fixed monthly repayments</div>
              <div className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-teal-500"/> No collateral required</div>
              <div className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-teal-500"/> No early repayment fees</div>
            </div>
            <button onClick={() => scrollTo('quote')} className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[#0a2540] hover:text-teal-600 transition-colors">
              Speak to a funding advisor <ArrowUpRight size={14}/>
            </button>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-xl">
              <img
                src="https://images.unsplash.com/photo-1730382624709-81e52dd294d4"
                alt="Business growth"
                className="w-full h-[420px] object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl border border-slate-200 shadow-xl p-5 max-w-[220px]">
              <div className="text-3xl font-bold text-[#0a2540]">98%</div>
              <div className="text-sm text-slate-500 mt-1">Applications approved within 24 hours</div>
            </div>
          </div>
        </div>

        <div className="mt-24">
          <div className="flex items-end justify-between flex-wrap gap-4">
            <div>
              <span className="chip">Use of Funds</span>
              <h3 className="mt-4 text-3xl md:text-4xl font-bold text-[#0a2540] tracking-tight">What could you use the funding for?</h3>
            </div>
            <p className="text-slate-600 max-w-md">Use your funding however your business needs it — there are no restrictions on spend.</p>
          </div>

          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {fundingUses.map((f, i) => {
              const Icon = LI[f.icon];
              return (
                <div key={f.title} className="tilt-card group relative bg-white border border-slate-200 rounded-2xl p-6 overflow-hidden">
                  <div className="absolute top-4 right-4 text-slate-300 text-xs font-mono">0{i+1}</div>
                  <div className="h-12 w-12 rounded-xl bg-teal-50 flex items-center justify-center text-teal-600 group-hover:bg-teal-600 group-hover:text-white transition-colors">
                    {Icon && <Icon size={22}/>}
                  </div>
                  <h4 className="mt-5 text-lg font-semibold text-[#0a2540]">{f.title}</h4>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{f.desc}</p>
                  <button onClick={() => scrollTo('quote')} className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-[#0a2540] group-hover:text-teal-600 transition-colors">
                    Learn more <ArrowUpRight size={14}/>
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
